export default "__VITE_ASSET__6ogD02HW__"